import { render, staticRenderFns } from "./IntroVideoPlayerWrapper.vue?vue&type=template&id=6b77e0a4&"
import script from "./IntroVideoPlayerWrapper.vue?vue&type=script&lang=ts&"
export * from "./IntroVideoPlayerWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports